import { createContext } from 'react';
import { GroupResource, SellerResource } from '~/api';
import { SellerData } from './index';

export type SellerContextProps = {
  loading: boolean;
  error?: string;
  getCurrentSeller: () => SellerData | null;
  getResourceConfig: () => (GroupResource | SellerResource)[];
  refetchSeller: () => void;
};

export const SellerContext = createContext<SellerContextProps>({
  loading: false,
  getCurrentSeller: () => null,
  getResourceConfig: () => [],
  refetchSeller: () => null,
});
